import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: './assigned-service-centers.component.html',
    standalone: false
})
export class AssignedServiceCentersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
